module.exports = __webpack_public_path__ + "media/images/athletes/2813-4b2d5ee69f8793b12d0da3ee673f1795.png";